/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_3_DescInputs */

const en_pc_rv_3_desc = /** @type {(inputs: Pc_Rv_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layered files open with groups, masks, type and styles intact, then save back for colleagues who stay on Photoshop.`)
};

const zh_pc_rv_3_desc = /** @type {(inputs: Pc_Rv_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分层文件打开后图层组、蒙版、文字和样式都完整保留，存回去还能给仍用 Photoshop 的同事继续编辑。`)
};

/**
* | output |
* | --- |
* | "Layered files open with groups, masks, type and styles intact, then save back for colleagues who stay on Photoshop." |
*
* @param {Pc_Rv_3_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_3_desc = /** @type {((inputs?: Pc_Rv_3_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_3_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_3_desc(inputs)
	return zh_pc_rv_3_desc(inputs)
});
export { pc_rv_3_desc as "pc.rv.3.desc" }